import { DefaultMonthsColumns } from "../../../Utils/DefaultData";

export const DatosEditablesLatex =
{
    InventarioInicial: { rowName: 'Inventario Inicial', ...DefaultMonthsColumns },
    ProduccionFca: { rowName: '(+) Produccion Fca.', ...DefaultMonthsColumns },
    ComprasProdExp: { rowName: '(+) Compras Prod/Exp', ...DefaultMonthsColumns },
    ComprasDelMesLocal: { rowName: '(+) Compras del mes local', ...DefaultMonthsColumns },
    AjusteAlInventario06Porciento: { rowName: '(+) Ajuste al inventario 0.06 %', ...DefaultMonthsColumns },
    AjusteAlInventarioPorMerma: { rowName: '(-) Ajuste al inventario por merma', ...DefaultMonthsColumns, isNegative: true },
}

export const TotalesLatex =
{
    // CtoPromedioDelInvenTotal: { rowName: 'Cto. Promedio del Inven. Total', ...DefaultMonthsColumns },
    SalidasAProduccion: { rowName: 'Salidas a producción', ...DefaultMonthsColumns },
    // InventarioFinal: { rowName: 'Inventario Final', ...DefaultMonthsColumns },
}

export const LatexData = {
    ...DatosEditablesLatex,
    ...TotalesLatex
}

export const EditableRowNames = Object.keys(DatosEditablesLatex);
export const TotalRowNames = [
    'Cto. Promedio del Inven. Total',
    'Salidas a producción',
    'Inventario Final'
]
